module.exports = __webpack_public_path__ + "static/media/Merriweather-Italic.050f1305.ttf";